import type { CategoryKey } from "@/types/content";

const styles: Record<CategoryKey, string> = {
  film: "bg-primary-100 text-primary-800",
  music: "bg-accent-100 text-accent-800",
  lifestyle: "bg-background-200 text-foreground-800",
  brand: "bg-secondary-100 text-secondary-800",
};

interface CategoryBadgeProps {
  categoryKey: CategoryKey;
  name: string;
}

export default function CategoryBadge({ categoryKey, name }: CategoryBadgeProps) {
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${styles[categoryKey]}`}
    >
      {name}
    </span>
  );
}